import Action from '@/common/action'
import { LinearEncoding, NoToneMapping, PCFSoftShadowMap, sRGBEncoding, WebGLRenderer } from 'three'

class GlobalRenderer {
  el: HTMLCanvasElement
  #renderer: WebGLRenderer
  #usePostEffects = true

  allowBloomOnTokens = false

  onContextLost = new Action<void>()
  onPostEffectsChange = new Action<void>()

  constructor() {
    this.el = document.createElement('canvas')
    this.el.style.position = 'absolute'
    this.el.style.top = '0px'
    this.el.style.left = '0px'
    this.el.style.width = '100%'
    this.el.style.height = '100%'
    this.el.style.zIndex = '0'

    const antialias = false
    // if (Detector.isRetina && Detector.isDesktop) {
    // antialias = false
    // }

    // if (Detector.isMobile) {
    //  antialias = false
    //  useShadows = false
    // }

    // if (window.INTERLAND.quality === QUALITY_LOW) {
    //  antialias = false
    // }

    this.#renderer = new WebGLRenderer({
      canvas: this.el,
      antialias: false,
      alpha: true,
      stencil: true,
      preserveDrawingBuffer: false,
      powerPreference: 'high-performance'
    })

    this.#renderer.autoClear = false //this.#usePostEffects ? false : true
    this.#renderer.outputEncoding = this.#usePostEffects ? LinearEncoding : sRGBEncoding

    this.#renderer.info.autoReset = false
    this.#renderer.setClearColor(0x000000)
    this.#renderer.setClearAlpha(1)
    this.#renderer.toneMapping = NoToneMapping
    this.#renderer.shadowMap.enabled = true
    this.#renderer.shadowMap.type = PCFSoftShadowMap

    this.#renderer.setPixelRatio(window.devicePixelRatio)

    this.el.addEventListener(
      'webglcontextlost',
      e => {
        e.preventDefault()
        this.onContextLost.invoke()
        /*const extension = this.#renderer.extensions.get('WEBGL_lose_context')
        if (extension) {
          try {
            extension.restoreContext()
          } catch (err: any) {
            console.log('hard reload')
          }
        }*/
      },
      false
    )

    //this.resize(this.#size)
  }

  get usePostEffects() {
    return this.#usePostEffects
  }

  set usePostEffects(value: boolean) {
    this.#usePostEffects = value
    this.#renderer.outputEncoding = this.#usePostEffects ? LinearEncoding : sRGBEncoding
    this.onPostEffectsChange.invoke()
  }

  getRenderer() {
    return this.#renderer
  }

  /*
    resize() {
      const size = container.resolve<ISize>(Token.ISize).getSize()
      this.#size = Object.assign(this.#size, size)

      this.#renderer.setSize(this.#size.width / this.#size.sizeRatio, this.#size.height / this.#size.sizeRatio)

      if (this.#size.sizeRatio > 1) {
        this.#renderer.domElement.style.transform =
          'scale3d(' + this.#size.sizeRatio + ', ' + this.#size.sizeRatio + ', 1)'
        this.#renderer.domElement.style.transformOrigin = '0 0 0'
        this.#renderer.domElement.style.webkitTransform =
          'scale3d(' + this.#size.sizeRatio + ', ' + this.#size.sizeRatio + ', 1)'
        this.#renderer.domElement.style.webkitTransformOrigin = '0 0 0'
      }
    }
  */
}

export default new GlobalRenderer()
